import { Box } from '@mui/material';

interface ICenter {
  children: any;
}

export default function Center({children}:ICenter) {
  return (
    <Box sx={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '90vh'}}>
      {children}
    </Box>
  )
}
